module.exports = "<!--<p>{{card.id}}</p>-->\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/remote/card/card.component.html
// module id = ./src/app/remote/card/card.component.html
// module chunks = main